/**
 * PAYLAŞIMLI MÜŞTERİ RAPORU — /r/<token>, login GEREKTİRMEZ.
 * Ajans müşterisine tek link gönderir; sayfada ajansın markası görünür (white-label),
 * müşteri "Raporu İndir (PDF)" ile aynı çıktıyı alabilir.
 */
import { useEffect, useState } from "react";
import { ReportBody, type ReportData, type AgencyBranding } from "@/components/report-body";
import { Loader2, ShieldAlert } from "lucide-react";

type Payload = { report: { target: string; market: string; createdAt: string; data: ReportData }; branding: AgencyBranding | null };

export default function SharedReport({ token }: { token: string }) {
  const [data, setData] = useState<Payload | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`/api/shared-report/${encodeURIComponent(token)}`)
      .then(async (r) => {
        const j = await r.json();
        if (!r.ok) throw new Error(j.error ?? "Rapor bulunamadı");
        setData(j);
      })
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, [token]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="text-center">
          <ShieldAlert className="mx-auto h-10 w-10 text-gray-300" />
          <p className="mt-3 text-gray-600 dark:text-gray-300">{error}</p>
          <p className="mt-1 text-theme-xs text-gray-400">Linki gönderen kişiden yeni bir paylaşım linki isteyebilirsin.</p>
        </div>
      </div>
    );
  }
  if (!data) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <div className="mx-auto max-w-[1280px] space-y-5 p-4 md:p-6" id="rapor-govde">
        <ReportBody d={data.report.data} branding={data.branding} />
      </div>
    </div>
  );
}
